import * as Config from '../../../../config';
import { useState, useCallback, useEffect } from 'react';

const useWaveform = (index, src, active) => {
  const [dimension, setDimension] = useState(null);
  const [context, setContext] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(null);
  const canvasID = `wc${index}`;
  const blockID = `block${index}`;
  
  const draw = useCallback((img, canvasID) => () => {
    let canvas = document.getElementById(canvasID);
    if (canvas) {
      let ctx = canvas.getContext("2d");
      const dpi = window.devicePixelRatio;
      ctx.scale(dpi, dpi);
      ctx.imageSmoothingQuality = `high`;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = "source-atop";
      ctx.fillStyle = Config.BLACK_5;
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      setContext({ ctx, canvas, dpi })
    }
  }, []);

  useEffect(() => { // Hover SVG
    if (dimension && active) {
      document.getElementById(`icf-seek`).addEventListener(`mouseleave`, (e) => {
        setCursorPosition(null);
      });
      document.getElementById(`icf-seek`).addEventListener(`mouseenter`, (e) => {
        const x = e.offsetX / window[`window_zoom`];
        setCursorPosition(x);
      });
      document.getElementById(`icf-seek`).addEventListener(`mousemove`, (e) => {
        const x = e.offsetX / window[`window_zoom`];
        if (x > 10) { setCursorPosition(x); }
      })
    }
  }, [dimension, active])

  useEffect(() => {
    if (!dimension) {
      setTimeout(() => {
        const el = document.getElementById(blockID);
        if (el) {
          setDimension({ width: (el.getAttribute(`basewidth`) * 2) , height: Math.round(el.getAttribute(`basewidth`) * 0.35) })
        }
      }, 100)
    } else {
      var img = new Image();
      img.onload = draw(img, canvasID);
      if (src) {
        img.src = src.replace(`1500x250`, `${dimension.width}x${dimension.height}`);
      }
    }
  }, [dimension, draw, blockID, canvasID, src])

  const customHook = {
    dimension, 
    context, 
    cursorPosition
  };

  return customHook;
};

export default useWaveform;
